import { buttonBaseClasses, MenuItem, selectClasses, inputBaseClasses } from "@mui/material";
import styled from "@emotion/styled";

export const StyledMenuItem = styled(MenuItem)(({ theme, error }) => ({
  "color": error && theme.palette.error[500],
  padding: theme.spacing(1, 2),
  borderRadius: "8px",
  flexDirection: "column",
  alignItems: "flex-start",
  maxWidth: "100%",
  overflow: "hidden",
  "&:not(:last-child)": {
    marginBottom: "4px"
  },
  "&:has(.description)": {
    fontSize: "16px"
  }
}));

export const StyledSearchBar = styled("div")({
  paddingBottom: "12px",
  width: "100%"
});

export const InputSx = (loading) => ({
  borderRadius: "8px",
  backgroundColor: "white",
  ...(loading && {
    [`.${selectClasses.outlined}::after`]: {
      content: "'Loading...'",
      color: "rgba(45, 44, 68, 0.4)"
    }
  })
});

export const SelectSx = (showPlaceholder, placeholder) => ({
  [`& .${selectClasses.select}`]: {
    paddingBlock: 0,
    paddingLeft: 0,
    paddingRight: "20px",
    height: "100%",
    whiteSpace: "normal",
  },
  ...(showPlaceholder ? {
    [`& .${selectClasses.select} span::before`]: {
      content: `"${placeholder}"`,
      color: "rgba(45, 44, 68, 0.4)"
    }
  } : {})
});

export const MenuSx = {
  padding: "0px",
  marginTop: "4px",
  overflowX: "hidden",
  [`.${buttonBaseClasses.root}[aria-selected='true']`]: {
    background: "#EBEBFD"
  },
  [`.${buttonBaseClasses.root}[aria-selected='true']:hover`]: {
    background: "#EBEBFD"
  }
};
